import { render, staticRenderFns } from "./seguimiento_pornit.vue?vue&type=template&id=f18e1782"
import script from "./seguimiento_pornit.js?vue&type=script&lang=js&external"
export * from "./seguimiento_pornit.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports